<template>
    <b-form-checkbox :id="'cb' + id" switch @change="billTask()" />
</template>

<script>
import DataUpdater from '../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'BillingSwitch',

    mixins: [DataUpdater],

    props: {
        id: {
            type: Number,
            required: true,
        },
    },

    methods: {
        async billTask() {
            try {
                await this.$axios.put(`/clientEvents/${this.id}/bill`)
                this.updateData()
            } catch (error) {
                error.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
